import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import sha256 from 'crypto-js/sha256';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useTranslation } from 'react-i18next';
import Cropper from 'react-easy-crop';


function Pictures({ dragHandleProps }) {
  const { t } = useTranslation();
  let LanguageSelected = Cookies.get('LanguageSelected');

  const apiUrl = process.env.REACT_APP_BACKEND_URL
  const ImageUrl = process.env.REACT_APP_IMAGES_URL

  const [Imagecontent, setImagecontent] = useState('')

  let userId = Cookies.get('userId');
  let UserToken = Cookies.get('UserSpecialToken');

  const hashedUserId = sha256((String(userId)));

  const [ImageModal, setImageModal] = useState(false)

  const [Done, setDone] = useState(false)
  const [InputsErrors, setInputsErrors] = useState([])

  const [ImagesId, setImagesId] = useState()

  const [ImagesContent, setImagesContent] = useState([])

  const [isFetching, setIsFetching] = useState(false);

  const responsive = {
    desktop: {
      breakpoint: { max: 4000, min: 700 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 2000, min: 500 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };

  function compressImage(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const maxWidth = 800; // Set your desired max width
          const maxHeight = 600; // Set your desired max height
          let newWidth = img.width;
          let newHeight = img.height;

          if (img.width > maxWidth || img.height > maxHeight) {
            const aspectRatio = img.width / img.height;
            if (aspectRatio > 1) {
              newWidth = maxWidth;
              newHeight = maxWidth / aspectRatio;
            } else {
              newHeight = maxHeight;
              newWidth = maxHeight * aspectRatio;
            }
          }

          canvas.width = newWidth;
          canvas.height = newHeight;
          ctx.drawImage(img, 0, 0, newWidth, newHeight);

          canvas.toBlob((blob) => {
            resolve(new File([blob], file.name, { type: file.type }));
          }, file.type, 0.7); // Adjust compression quality here (0.7 = 70%)
        };
      };
      reader.readAsDataURL(file);
    });
  }

  const AddingImagePhotoInfo = async (e) => {
    let Picture = e.target.files[0]
    if (!Picture) {
      toast.error('No image selected');
      return;
    }

    const allowedExtensions = ['png', 'jpg', 'jpeg', 'gif'];
    const maxSize = 20 * 1024 * 1024; // 20 MB in bytes

    const extension = Picture.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(extension)) {
      toast.error('Invalid image format. Allowed formats: PNG, JPG, JPEG, GIF');
      return;
    }

    if (Picture.size > maxSize) {
      toast.error('Image size exceeds 20 MB');
      return;
    }

    handleImageCrop(e, Picture)

  }

  useEffect(() => {
    fetch(`${apiUrl}/GetPictureInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ user_id: userId })


    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setImagesContent(result.data)


        }
      })
  }, [Done])



  const StorePictureInfo = async (e) => {
    e.preventDefault()

      setIsFetching(true);

      let Image
      Image = croppedImage ?  await convertBlobToBase64(croppedImage) : null;

      axios
        .post(`${apiUrl}/StorePictureInfo`, { Image }, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${UserToken}`,
          },
        })
        .then(result => {
          if (result.data.success) {
            setDone(!Done)
            setImageToCrop(null)
            setCroppedImage(null)
            setInputsErrors([])
            setZoom(1)

            setImagecontent('')
            setImageModal(false)
            toast.success(result.data.message, {
              position: toast.POSITION.CENTER
            });

          }
          else {
            setInputsErrors(result.data.errors)

          }
        })
        .finally(() => {
          setIsFetching(false);
        });

    




  }

  const DeletePictureInfo = (e, id) => {
    e.preventDefault()

    fetch(`${apiUrl}/DeletePictureInfo`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${UserToken}`


      },
      body: JSON.stringify({ ImagesId: id })
    })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          setDone(!Done)

        }
      })
  }


  const [CropImage, setCropImage] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [croppedImage, setCroppedImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (ImageModal || CropImage) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
  }, [ImageModal, CropImage]);


  const [imageToCrop, setImageToCrop] = useState(null);

  const onCropChange = (crop) => {
    setCrop(crop);
  };

  const onZoomChange = (zoom) => {
    setZoom(zoom);
  };



  const handleImageCrop = (e, fileImage) => {
    const file = fileImage;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImageToCrop(reader.result);
      };
      reader.readAsDataURL(file);
    }

    // Set state to control UI, like showing cropped image or closing modal

    setCropImage(true);
  };


  const handleCropComplete = async (_, croppedAreaPixels) => {
    try {
      const croppedImageBlob = await getCroppedImageBlob(imageToCrop, croppedAreaPixels);
      const compressedFile = await compressImage(croppedImageBlob);
      setCroppedImage(compressedFile);
    } catch (error) {
      console.error('Error cropping image:', error);
    }
  };
  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  };

  const getCroppedImageBlob = (imageSrc, croppedAreaPixels) => {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = imageSrc;
      const canvas = document.createElement('canvas');
      canvas.width = croppedAreaPixels.width;
      canvas.height = croppedAreaPixels.height;
      const ctx = canvas.getContext('2d');

      image.onload = () => {
        ctx.drawImage(
          image,
          croppedAreaPixels.x,
          croppedAreaPixels.y,
          croppedAreaPixels.width,
          croppedAreaPixels.height,
          0,
          0,
          croppedAreaPixels.width,
          croppedAreaPixels.height
        );
        canvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/jpeg');
      };
    });
  };




  return (
    <div className={`${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>

      <section className="info  m-3">




        <div className="rounded-xl p-4  sections pb-5">
          <div className="pb-2 ">
            <h1 className="title title--h1 first-title title__separate text-theme">{t("Images")}</h1>
          </div>
          <div className="pb-0 pr-2 ">

            <div className="grid grid-cols-1 js-masonry   js-filter-container">
              <div className="" />


              <Carousel className='' responsive={responsive}>
                {ImagesContent.map((image, index) => (
                  <div key={index} className="gallery-grid__image-wrap  relative">
                    <img
                      className="gallery-grid__image cover  ml-2 lazyload "
                      src={`${ImageUrl}/${hashedUserId}/${image.Image}`}
                      data-zoom
                      alt=""
                    />
                    <svg
                      onClick={(e) => { DeletePictureInfo(e, image.id); }}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="w-8 h-8 sections rounded-lg p-0.5 font-bold absolute right-2 bottom-2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                      />
                    </svg>
                  </div>
                ))}
              </Carousel>



              <a onClick={() => { setImageModal(true) }}>

                <main className="flex pl-3 pb-3 mt-5  items-center justify-center ">
                  <label htmlFor="dropzone-file-imagas" className="mx-auto cursor-pointer flex w-full max-w-lg flex-col items-center rounded border-2 border-dashed border-gold div-sections p-6 text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6 text-theme">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="mt-2 text-about tracking-wide">{t("Entrez vos images.")} </p>
                  </label></main></a>
            </div>
          </div>
          <div className="drag-handle flex justify-center pt-2 text-theme" {...dragHandleProps}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
              <path fill-rule="evenodd" d="M17.303 5.197A7.5 7.5 0 006.697 15.803a.75.75 0 01-1.061 1.061A9 9 0 1121 10.5a.75.75 0 01-1.5 0c0-1.92-.732-3.839-2.197-5.303zm-2.121 2.121a4.5 4.5 0 00-6.364 6.364.75.75 0 11-1.06 1.06A6 6 0 1118 10.5a.75.75 0 01-1.5 0c0-1.153-.44-2.303-1.318-3.182zm-3.634 1.314a.75.75 0 01.82.311l5.228 7.917a.75.75 0 01-.777 1.148l-2.097-.43 1.045 3.9a.75.75 0 01-1.45.388l-1.044-3.899-1.601 1.42a.75.75 0 01-1.247-.606l.569-9.47a.75.75 0 01.554-.68z" clip-rule="evenodd" />
            </svg>

          </div>
        </div>


      </section>

      {ImageModal &&
        <div>

          <div className="minscreen h-full overflow-auto animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 picturesform forms-info ">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => { setImageModal(false); setImageToCrop(null); setCroppedImage(null); setInputsErrors([]) }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full max-w-sm  p-8  rounded-md">
              <h2 className="text-3xl text-theme mb-2">{t("Images")}</h2>
              <form className="space-y-6 text-about">
                <div>
                  <label htmlFor="image" className="textModal "> {t("Exprimez votre personnalité et démontrez votre savoir-faire à travers cette galerie d'images")}</label>
                  {croppedImage &&
                    <div className='relative'>
                      <div className='w-44 h-44'>
                        <img className="cover w-full h-full preview-image   rounded-xl mt-4" src={URL.createObjectURL(croppedImage)} alt="Preview" />

                      </div>
                      <a onClick={() => { setCroppedImage(null); setImageToCrop(null) }}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 absolute right-1 top-1  text-white div-sections opacity-50 rounded-xl  cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                        </svg>
                      </a>
                      <p className="mt-2 text-center text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Image') && InputsErrors.Image}</span></p>

                    </div>
                  }

                  <div className="flex items-center justify-center w-full">
                    {!croppedImage &&

                      <label htmlFor="dropzone-file-portfolio" className="flex flex-col items-center justify-center w-full h-44 mt-5 border-2 border-gold border-dashed rounded-lg cursor-pointer div-sections">
                        <div className="relative flex flex-col items-center justify-center pt-5 pb-6">
                          <svg aria-hidden="true" className="w-10 h-10 mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12">
                            </path>
                          </svg>
                          <center>
                            <p className="mb-2 text-sm text-gray-300">
                              <span className="font-semibold">{t("Cliquez pour télécharger")}</span>
                            </p>
                          </center>
                          <p className="text-xs text-gray-400">SVG, PNG, JPG, or GIF (MAX. 800x400px)</p>
                          <p className="mt-2 text-center text-red-600"><span className="font-xsmall">{InputsErrors.hasOwnProperty('Image') && InputsErrors.Image}</span></p>

                        </div>
                        <input onChange={(e) => { AddingImagePhotoInfo(e) }} id="dropzone-file-portfolio" type="file" name='Image' className="hidden" />
                      </label>}
                  </div>

                </div>

                <button onClick={(e) => StorePictureInfo(e)} type="submit" className="w-full btn-edit">
                  {t("enregistrer")}
                </button>
              </form></div>
          </div>
        </div>


      }




      {CropImage &&
        <div>
          <div className="minscreen overflow-auto h-full animated fadeIn faster fixed left-0 top-0 flex justify-center items-center inset-0 z-1000 forms-info">
            <div className="absolute top-0 right-0 p-4">
              <a className='w-12 h-12' onClick={() => {
                setCropImage(false); setCroppedImage(null);
                setImageToCrop(null);
                setZoom(1)

              }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                </svg>
              </a>
            </div>
            <div className="w-full text-about settingswidth p-8">
              <div className="flex flex-col items-left justify-start mt-8">
                <p className="text-md text-gold ">
                  {t("Recadrez votre photo pour un meilleur rendu")}
                </p>
              </div>


              <div className='flex flex-col items-center justify-center p-6'>
                {imageToCrop && (
                  <div className=" crop-container w-full ">
                    <Cropper
                      image={imageToCrop}
                      crop={crop}
                      zoom={zoom}
                      aspect={4 / 4}
                      onCropChange={onCropChange}
                      onZoomChange={onZoomChange}
                      onCropComplete={handleCropComplete}
                    />
                  </div>
                )}
                <div className=" controls">
                  <label for="zoom-input" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Zoom : </label>
                  <input id="zoom-input" type="range"
                    min={1}
                    max={3}
                    step={0.1}
                    value={zoom}
                    onChange={(e) => onZoomChange(parseFloat(e.target.value))}
                    className="w-full h-2 mb-6 bg-gray-200 rounded-lg appearance-none cursor-pointer text-gold" />

                </div>
                {croppedImage && (
                  <div className=" cropped-image-container">
                    <div className="flex flex-col items-left justify-start mt-2 mb-4">
                      <p className="text-md text-gold ">
                        {t("Image Recadrer")}
                      </p>
                    </div>
                    <div className='crop-image'>
                      <img src={URL.createObjectURL(croppedImage)} alt="Cropped" />

                    </div>
                  </div>
                )}
              </div>



              <div>
                <button
                  onClick={(e) => { setCropImage(false) }}
                  type="submit"
                  className="w-full btn-edit"
                >
                  {t("enregistrer")}
                </button>
              </div>
            </div>
          </div>
        </div>

      }





    </div>
  )

}

export default Pictures